import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Person} from '../person';

@Component({
  selector: 'app-manage-people-list',
  templateUrl: './manage-people-list.component.html',
  styleUrls: ['./manage-people-list.component.scss']
})
export class ManagePeopleListComponent implements OnInit {

  @Input() public people:Person[]
  @Output() public peopleChange:EventEmitter<Person[]> = new EventEmitter<Person[]>();

  constructor() { }

  ngOnInit() {
    if(!this.people){
      this.people = [];
    }
  }

  changesMade(){
    this.peopleChange.emit(this.people)
  }
  addPerson(){
    this.people.push(new Person());
  }

}
